import React, { useState, useEffect, useRef } from "react";
import ListOfMyCoaches from "../../components/ListOfMyCoaches/ListOfMyCoaches";
import { ContentFilters, GeneralMyCoach } from "./MyCoachesContainer.styled";
import GeneralFiltersContainer from "../GeneralFiltersContainer/GeneralFiltersContainer";
import { theme as themeConfig } from "../../themes/themes";
import ModalDetailMyCoach from "../../components/ModalDetailMyCoach/ModalDetailMyCoach";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  ABOUTME,
  ALL_MY_COACH,
  CURRENT_USER_INFO,
} from "../../GraphQL/Queries";
import { NotificationManager } from "react-notifications";
import ModalAppointment from "../../components/ModalAppointment/ModalAppointment";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import {
  ADD_NEW_EVENT,
  PARTICIPANT_ATTEND_CHANGE,
} from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { getFile } from "../../services/FileManager";
import Paper from "@material-ui/core/Paper";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import SearchComponent from "../../components/SearchComponent/SearchComponent";
import { ReactComponent as EngagementIcon } from "../../assets/svg/engagement-header-icon.svg";
import HeaderComponent from "../../components/Header/Header";

const MyCoachesContainer = () => {
  const filtersViews = {
    initialDate: true,
    finalDate: true,
    search: {
      show: false,
      label: "Search(Name or description)",
    },
  };
  const history = useHistory();
  const [user] = useState(getStateLoginComplete());
  const [coaches, setCoaches] = useState([]);
  const [openReadMoreModal, setOpenReadMoreModal] = useState(null);
  const [openAppointmentModal, setOpenAppointmentModal] = useState(null);
  const [dataFilter, setDataFilter] = useState({});
  const [filtered, setFiltered] = useState(false);
  const [userData, setUserData] = useState({});
  const [eventId, setEventId] = useState(null);
  const [previewImages, setPreviewImages] = useState([]);
  const rSearch = useRef();
  const [searchText, setSearchText] = useState();
  const [actualDate] = useState(new Date());

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    filterEvents();
  }, [searchText]);

  const [participantAttendChange] = useMutation(PARTICIPANT_ATTEND_CHANGE, {
    client: clientWellness,
  });
  const [addNewEvent] = useMutation(ADD_NEW_EVENT, {
    client: clientWellness,
  });
  const [
    runQueryAllMyCoach,
    { loading: loadingAllMyCoach, error: errorAllMyCoach },
  ] = useLazyQuery(ALL_MY_COACH, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const allMyCoaches = data.allMyCoaches.map((o) => ({ ...o }));
      if (allMyCoaches !== null && allMyCoaches) {
        asignDataFirst(allMyCoaches);
      } else {
        NotificationManager.error(
          "Something is wrong with the detail of the coach",
          "",
          5000
        );
      }
    },
  });

  const [runQueryAboutMe] = useLazyQuery(ABOUTME, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.aboutMe !== null && data.aboutMe) {
        setUserData(data.aboutMe);
      } else {
        NotificationManager.error(
          "Something is wrong with the data of the user",
          "",
          5000
        );
      }
    },
  });

  const [runQueryUserInfo] = useLazyQuery(CURRENT_USER_INFO, {
    context: { clientName: "LinkUsers" },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.currentUser[0]?.userId) {
        let userDetail = data.currentUser[0];
        setUserData(userDetail);
      } else {
        NotificationManager.error(
          "Something is wrong with the data of the user",
          "",
          5000
        );
      }
    },
  });

  useEffect(() => {
    if (!filtered) {
      runQueryAllMyCoach({
        variables: {
          searchBy: "",
          startDate: null,
          finishDate: null,
        },
      })
        .then((response) => {
          if (response?.errors) {
            NotificationManager.warning(response.errors[0].message, "", 5000);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [filtered]);

  useEffect(() => {
    if (openAppointmentModal) {
      runQueryUserInfo();
    }
  }, [openAppointmentModal]);

  useEffect(() => {
    if (eventId) {
      NotificationManager.success("Event created", "", 5000);
      goToReloadPage();
    }
  }, [eventId]);

  let goToReloadPage = () => {
    history.push({
      pathname: `/CoachesManagement`,
    });
    setTimeout(() => {
      history.push({
        pathname: `/MyCoaches`,
      });
    }, 0);
  };

  const asignDataFirst = (data) => {
    if (data.length > 0) {
      let count = 0;
      let images = [];
      setCoaches(data);
      data.map((element) => {
        element.coverImage !== "" &&
          getFile(element.coverImage).then((response) => {
            count += 1;
            if (response && response.type !== "archivo-noexistente/json") {
              images.push({
                nameImage: element.coverImage,
                urlImage: URL.createObjectURL(response),
              });
              setPreviewImages([...images]);
            }
          });
      });
    }
  };

  let filterEvents = () => {
    setFiltered(true);
    runQueryAllMyCoach({
      variables: {
        searchBy: searchText ? searchText : "",
        startDate: dataFilter.initialDate ? dataFilter.initialDate : null,
        finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
      },
    })
      .then((response) => {
        if (response.errors) {
          NotificationManager.error(response.errors[0].message, "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleAppointment = (item) => {
    setOpenAppointmentModal(item);
  };

  let handleSeeAvailabilty = (coach) => {
    history.push({
      pathname: `/MyCoachAvailability`,
      state: { coach: coach },
    });
  };

  let handleSeeDetails = (coach) => {
    setOpenReadMoreModal(coach);
  };

  let confirmAppointment = (item) => {
    if (
      item.cityId &&
      item.countryId &&
      item.eventCategoryId &&
      item.eventDescription &&
      item.eventName &&
      item.eventStatus &&
      item.eventType &&
      item.languageId &&
      item.startDate &&
      item.finishDate &&
      item.participantIsRequired
    ) {
      addNewEvent({
        variables: {
          cityId: item.cityId,
          countryId: item.countryId,
          eventCategoryId: item.eventCategoryId,
          eventDescription: item.eventDescription,
          eventName: item.eventName,
          eventStatus: item.eventStatus,
          eventType: item.eventType,
          eventUri: item.eventUri,
          finishDate: item.finishDate,
          groups: item.groups,
          individualGuests: item.individualGuests,
          languageId: item.languageId,
          participantIsRequired: item.participantIsRequired,
          participantsLimit: item.participantsLimit,
          photoUri: item.photoUri,
          speakers: item.speakers,
          startDate: item.startDate,
        },
      })
        .then((response) => {
          if (response.errors) {
            NotificationManager.error(response.errors[0].message, "", 5000);
          } else {
            if (response.data.addNewEvent.idEvent) {
              saveAccept(
                response.data.addNewEvent.idEvent,
                item.individualGuests
              );
              setEventId(response.data.addNewEvent.idEvent);
            }
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning("Missing fields", "", 5000);
    }
  };

  const saveAccept = (idEvent, userIds) => {
    participantAttendChange({
      variables: {
        eventId: idEvent,
        userId: userIds[0],
        participantAttend: "Accept",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
    participantAttendChange({
      variables: {
        eventId: idEvent,
        userId: userIds[1],
        participantAttend: "Accept",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
  };

  const showReadMoreModal = () => {
    return openReadMoreModal ? (
      <ModalDetailMyCoach
        openReadMoreModal={openReadMoreModal}
        setOpenReadMoreModal={setOpenReadMoreModal}
      />
    ) : null;
  };

  const showAppointmentModal = () => {
    return openAppointmentModal ? (
      <ModalAppointment
        userData={userData}
        confirmAppointment={confirmAppointment}
        openAppointmentModal={openAppointmentModal}
        setOpenAppointmentModal={setOpenAppointmentModal}
      />
    ) : null;
  };

  return (
    <GeneralMyCoach>
      <HeaderComponent
        notIncludeHeight={true}
        Icon={EngagementIcon}
        text={"My Coaches"}
      />
      <Paper position="static">
        <AntTabs aria-label="My Coaches" value={0}>
          <div>
            <AntTab label="My Coaches" id="mycoaches" value="0" valueTabs={0} />
          </div>
        </AntTabs>
      </Paper>
      <Row>
        <Col md={12}>
          <ContentFilters className={"p-4"}>
            <GeneralFiltersContainer
              filtersViews={filtersViews}
              FilterEvents={filterEvents}
              setDataFilter={setDataFilter}
              filtered={filtered}
              setFiltered={setFiltered}
            />
            <SearchComponent
              rSearch={rSearch}
              handleSearch={handleSearch}
              setSearchText={setSearchText}
            />
          </ContentFilters>
        </Col>
        <Col md={12}>
          {loadingAllMyCoach && !errorAllMyCoach && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <PointersLine color={themeConfig.text.primary} />
              </Col>
            </Row>
          )}
          {!loadingAllMyCoach && errorAllMyCoach && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
              </Col>
            </Row>
          )}
          {!loadingAllMyCoach && !errorAllMyCoach && (
            <ListOfMyCoaches
              coaches={coaches}
              previewImages={previewImages}
              handleAppointment={handleAppointment}
              handleSeeAvailabilty={handleSeeAvailabilty}
              handleSeeDetails={handleSeeDetails}
            />
          )}
        </Col>
      </Row>
      {showAppointmentModal()}
      {showReadMoreModal()}
    </GeneralMyCoach>
  );
};
export default MyCoachesContainer;
